export default __webpack_public_path__ + "static/media/wave-mobile.c2fd3cc7.webp";